import { normalizeImageCatalog } from '../utils/image-model-catalog.js';

const API_ENDPOINT = import.meta.env.VITE_SOGNI_REST_ENDPOINT || 'https://api.sogni.ai';

// Keep this array stable for the existing gallery/model-label consumers.
export const imageModels = $state([]);
export const modelCatalog = $state({
  status: 'idle', error: null, catalogVersion: null, updatedAt: null
});

let loading = null;

export async function loadImageModelCatalog({ force = false } = {}) {
  if (loading) return loading;
  if (!force && modelCatalog.status === 'ready') return imageModels;
  modelCatalog.status = 'loading';
  modelCatalog.error = null;
  loading = (async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/v1/model-catalog?mediaType=image&include=parameters`);
      if (!response.ok) throw new Error('Unable to load image models. Please retry.');
      const snapshot = await response.json();
      const models = normalizeImageCatalog(snapshot);
      imageModels.splice(0, imageModels.length, ...models);
      const data = snapshot.data ?? snapshot;
      modelCatalog.catalogVersion = data.catalogVersion;
      modelCatalog.updatedAt = data.updatedAt;
      modelCatalog.status = 'ready';
      return imageModels;
    } catch (error) {
      modelCatalog.status = 'error';
      modelCatalog.error = error.message || 'Unable to load image models.';
      throw error;
    } finally {
      loading = null;
    }
  })();
  return loading;
}

export function getCatalogModel(modelId) {
  return imageModels.find((model) => model.id === modelId);
}
